import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ReactTable from 'react-table';
import { redirectToAdminEditUserPage, redirectToAdminUserListPage } from '../../../redux/actions/navigationActions';
import { TableHeader } from './TableHeader';
import { usePrevious } from '../../../utils/customHooks';
import { CustomButton } from '../../../containers';
import { FormattedMessage } from 'react-intl';
import { setLocalStorageUsersFilter } from '../../../constants/LocalStorageKeys';

const PaginationComponent = ({ sector, filter, dispatch }) => {
  return (
    <CustomButton
      outline
      color="primary"
      className="hok-outline-btn mx-auto"
      translationId="showAll"
      onClick={() => {
        setLocalStorageUsersFilter(
          JSON.stringify({
            ...(sector && { sector }),
            ...(filter.verified !== undefined && { verified: filter.verified }),
          })
        );
        dispatch(redirectToAdminUserListPage());
      }}
    />
  );
};

export const UsersTable = ({ titleId, data, loading, columns, refetch, filter, fetchMore, take, queryCount }) => {
  const DEFAULT_PAGE_SIZE = 14;
  const dispatch = useDispatch();
  const [sector, setSector] = useState('');
  const prevSector = usePrevious(sector);

  useEffect(() => {
    if (prevSector !== undefined && prevSector !== sector) {
      refetch({
        filter: { ...(sector && { sector }), ...filter },
        order: { createdAt: 'DESC' },
        skip: 0,
        take,
      });
    }
  }, [sector, prevSector, refetch, filter, take]);

  const handleScroll = ({ currentTarget }) => {
    if (currentTarget.scrollTop + currentTarget.clientHeight >= currentTarget.scrollHeight) {
      onLoadMore();
    }
  };

  const onLoadMore = () => {
    if (data.length < queryCount) {
      fetchMore({
        variables: {
          filter: { ...(sector && { sector }), ...filter },
          order: { createdAt: 'DESC' },
          skip: data.length,
          take,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev;
          return Object.assign({}, prev, {
            getUsers: {
              ...fetchMoreResult.getUsers,
              users: [...prev.getUsers.users, ...fetchMoreResult.getUsers.users],
            },
          });
        },
      });
    }
  };

  return (
    <ReactTable
      TheadComponent={() => <TableHeader titleId={titleId} refetch={refetch} sector={sector} setSector={setSector} />}
      style={{ height: '700px' }}
      className="hok-admin-home-table mb-5 mb-md-0"
      columns={columns}
      data={data}
      loading={loading}
      manual
      minRows={DEFAULT_PAGE_SIZE}
      sortable={false}
      getTrProps={(_, rowInfo) => ({
        onClick: () => dispatch(redirectToAdminEditUserPage(rowInfo.original.id)),
      })}
      getTbodyProps={() => ({
        onScroll: handleScroll,
      })}
      PaginationComponent={() => <PaginationComponent sector={sector} filter={filter} dispatch={dispatch} />}
      loadingText={<FormattedMessage id="adminUsersListPage.tableLoading" />}
      noDataText={<FormattedMessage id="adminUsersListPage.tableNoData" />}
    />
  );
};
